import Vue from 'vue'
import Vuex from 'vuex'

import sessionStore from '@/stores/session'
import _ from 'underscore'

const manufacturers = ['Borne de recharge','BMW','Chevrolet','Ford','Hyundai','Kia','Nissan','Smart','Tesla','Toyota','Volkswagen']
const carStore = {
  namespaced: true,
  state: {
    manufacturers: manufacturers,
    carCreateData: [],
    cars: []
  },
  mutations: {
    SET_CARS(state, cars) {
      state.cars = cars
    },
    FILTER_POSSIBLE_CARS(state, data) {
      state.carCreateData = data
    }

  },
  actions: {
    reset({state, commit}) {
      commit('SET_CARS', [])
      commit('FILTER_POSSIBLE_CARS', [])
    },
    getManufacturerInfos({state, commit}, data) {
      // let promises = []
      // for (manufacturer of state.manufacturers) {
        // promises.push()
      // }
      // return Promise.all(promises);
      return Vue.axios.get(`/rest/cars/makers`, {params: data})
      .then((response)=> {
        commit('FILTER_POSSIBLE_CARS', response.data )
        return Promise.resolve(response)
      })
    },
    getCars({state, commit}) {
      // /rest/profil/{profileId}/cars
      return Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/cars/`).then((response) => { commit('SET_CARS', response.data) })
    },

    updateCar({commit}, carData) {
      return Vue.axios.put(`/rest/profile/${sessionStore.state.profileId}/cars`, carData)
      // PUT /rest/profile/{profileId}/cars/
    },

    deleteCar({commit}, profileCarId) {
      return Vue.axios.delete(`/rest/profile/${sessionStore.state.profileId}/cars`, { params: {profileCarId: profileCarId} })
    },

    createCar({commit, state, dispatch}, carData) {
      // The API have all the possible cars harcoded in the DB, and i need to match my form data to a set of object return from the API
      // to find the right carID.
      let saveData = _.find(state.carCreateData, (car) => { return (car.color == carData.color && car.manufacturer == carData.manufacturer && car.model == carData.model && car.year == carData.year) })

      if (!saveData) {
        return Promise.reject({message: 'Le formulaire contient des erreurs'})
      }
      saveData.carName      = carData.carName
      saveData.linkedDevice = carData.linkedDevice
      saveData.linkedPort   = carData.linkedPort
	  saveData.averageWhPerKm   = carData.averageWhPerKm
      console.log(saveData);
      return Vue.axios.post(`/rest/profile/${sessionStore.state.profileId}/cars`, carData)
    }
  }
}

export default carStore



// WEBPACK FOOTER //
// ./src/stores/cars.js